
import { Vue, Options } from "vue-property-decorator";
@Options({
  name: "identification-finish",
})
export default class IdentificationFinish extends Vue {}
